<script lang="ts">
  import { downloadText } from '../../app/browser';
  import { getServices } from '../../app/context';
  import { JSON_FILE_NAME, JSON_MIME, serializeDoc } from '../../io/json-file';
  import { strings } from '../../strings';
  import Button from '../../ui/Button.svelte';
  import Dialog from '../../ui/Dialog.svelte';

  const { store, importer } = getServices();
  // Follows the pending import; the dialog may also close itself (Escape).
  let open = $derived(importer.pending !== null);
</script>

<Dialog
  bind:open
  title={strings.openSharedTitle}
  description={strings.openSharedDescription}
  closeOnBackdrop={false}
  onclose={() => {
    importer.dismiss();
  }}
>
  {#snippet footer()}
    <Button
      variant="ghost"
      class="mr-auto"
      onclick={() => {
        downloadText(serializeDoc(store.doc), JSON_FILE_NAME, JSON_MIME);
      }}
    >
      {strings.downloadCurrent}
    </Button>
    <Button onclick={() => (open = false)}>{strings.cancel}</Button>
    <Button
      variant="primary"
      onclick={() => {
        importer.accept();
      }}
    >
      {strings.openShared}
    </Button>
  {/snippet}
</Dialog>
